import script from "./TopPlayerCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TopPlayerCard.vue?vue&type=script&setup=true&lang=js"

import "./TopPlayerCard.vue?vue&type=style&index=0&id=0ea77261&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ea77261"]])

export default __exports__